module.exports = __webpack_public_path__ + "img/startup.e939637e.png";